import {checkboxAnatomy as parts} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers, cssVar, defineStyle} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {runIfFn} from '../utils';

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys);

const $size = cssVar(`checkbox-size`);

const baseStyleControl = defineStyle(props => {
  const {colorScheme: c} = props;

  return {
    w: $size.reference,
    h: $size.reference,
    transitionProperty: `box-shadow`,
    transitionDuration: `normal`,
    border: `2px solid`,
    borderRadius: `4px`,
    borderColor: `inherit`,
    color: `white`,

    _checked: {
      bg: mode(`${c}.600`, `${c}.200`)(props),
      borderColor: mode(`${c}.600`, `${c}.200`)(props),
      color: mode(`white`, `gray.900`)(props),

      _hover: {
        bg: mode(`${c}.600`, `${c}.300`)(props),
        borderColor: mode(`${c}.600`, `${c}.300`)(props),
      },

      _disabled: {
        borderColor: mode(`gray.200`, `transparent`)(props),
        bg: mode(`gray.200`, `whiteAlpha.300`)(props),
        color: mode(`gray.600`, `whiteAlpha.600`)(props),
      },
    },

    _indeterminate: {
      bg: mode(`${c}.600`, `${c}.200`)(props),
      borderColor: mode(`${c}.600`, `${c}.200`)(props),
      color: mode(`white`, `gray.900`)(props),
    },

    _disabled: {
      bg: mode(`gray.100`, `whiteAlpha.100`)(props),
      borderColor: mode(`gray.100`, `transparent`)(props),
    },

    _focusVisible: {
      boxShadow: `outline`,
    },

    _invalid: {
      borderColor: mode(`red.600`, `red.300`)(props),
    },
  };
});

const baseStyleContainer = defineStyle({
  _disabled: {cursor: `not-allowed`},
});

const baseStyleLabel = defineStyle({
  userSelect: `none`,
  _disabled: {opacity: 0.4},
});

const baseStyleIcon = defineStyle({
  transitionProperty: `transform`,
  transitionDuration: `normal`,
});

const baseStyle = definePartsStyle(props => ({
  icon: baseStyleIcon,
  container: baseStyleContainer,
  control: runIfFn(baseStyleControl, props),
  label: baseStyleLabel,
}));

const sizes = {
  sm: definePartsStyle({
    control: {[$size.variable]: `sizes.3`},
    label: {fontSize: `sm`},
    icon: {fontSize: `3xs`},
  }),
  md: definePartsStyle({
    control: {[$size.variable]: `sizes.4`},
    label: {fontSize: `md`},
    icon: {fontSize: `2xs`},
  }),
  lg: definePartsStyle({
    control: {[$size.variable]: `sizes.5`},
    label: {fontSize: `lg`},
    icon: {fontSize: `2xs`},
  }),
};

export const checkboxTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: `md`,
    colorScheme: `blue`,
  },
});
